var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66666 14.2573C4.66666 8.12418 9.79183 3.16699 15.9913 3.16699C22.2081 3.16699 27.3333 8.12418 27.3333 14.2573C27.3333 17.3479 26.2093 20.2172 24.3593 22.6491C22.3184 25.3317 19.8029 27.6689 16.9714 29.5036C16.3233 29.9275 15.7385 29.9595 15.0273 29.5036C12.1796 27.6689 9.66411 25.3317 7.64066 22.6491C5.7893 20.2172 4.66666 17.3479 4.66666 14.2573ZM12.2595 14.603C12.2595 16.6576 13.9361 18.2735 15.9918 18.2735C18.0489 18.2735 19.7416 16.6576 19.7416 14.603C19.7416 12.5644 18.0489 10.8698 15.9918 10.8698C13.9361 10.8698 12.2595 12.5644 12.2595 14.603Z",
    fill: "#0799B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.5035cf1c0aa9e353c2dc901aba4b8cc4.svg";
export { ForwardRef as ReactComponent };